// © Microsoft Corporation. All rights reserved.

/**
 * Constants used by WPO
 */
export const WpoConstant = {
    /**
     * WPO flight identifier that will be used to enabled/disable WPO. As WPO runs before any config fetch we cannot rely on
     * config params to enable/disable WPO. This unique flight in the head-data is used to make decision.
     * We will also use an explicit PCS flag to enable/disable WPO that will override this flag for DRI use cases.
     */
    wpoFlightIdentifier: "prg-wpo-enabled"

};